import React, { useState, useContext } from "react"
import {
    Container,
    Form,
    Input,
    Button,
    Message
} from "semantic-ui-react"
import {
    UserContext,
    apiUrl
  } from '@dialectic-design/hyperobjects-user-context'
import _ from "lodash"

const NewArtworkPage = () => {
    const user = useContext(UserContext)
    const [newName, setNewName] = useState("")
    const [error, setError] = useState(false)
    const [success, setSuccess] = useState(false)
    return (
        <div className="new-artwork-page">
            <Container>
            <h2>New artwork</h2>
            {success ? (
                <Message positive>
                    Artwork successfully created.
                </Message>
            ) : (
                <div className='ui form'>
                    <Form.Field>
                        <label>Artwork name</label>
                        <Input
                            placeholder="artwork name..."
                            value={newName}
                            onChange={(e) => {
                                setNewName(e.target.value)
                                if(error === "Set a name." && e.target.value.length > 0) {
                                    setError(false)
                                }
                            }}
                            />
                    </Form.Field>
                    <Form.Field>
                        <Button
                            onPointerDown={() => {
                                if(newName.length === 0) {
                                    setError("Set a name.")
                                } else {
                                    fetch(apiUrl + `/admin/artwork`, {
                                        method: "POST",
                                        headers: {
                                            "Authorization": `Bearer ${user.token}`,
                                            "Content-Type":"application/json"
                                        },
                                        credentials: "include",
                                        body: JSON.stringify({
                                            name: newName
                                        })
                                    }).then(resp => {
                                        if(resp.status === 200) {
                                            setSuccess(true)
                                        } else if(resp.status === 400) {
                                            resp.json().then(data => {
                                                console.log(data)
                                                setError(_.get(data, "message", 'unknown error'))
                                            })
                                        } else {
                                            console.log(resp)
                                            setError(`connection error: ${resp.status}`)
                                        }
                                    })
                                }
                            }}
                            >
                            Create
                        </Button>
                    </Form.Field>
                    {error && (
                        <Message negative>
                            {error}
                        </Message>
                    )}
                </div>
            )}
            
            </Container>
        </div>
    )
}

export default NewArtworkPage